import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import DrawerState from "./state";

export default createSlice({
    name: "drawer",
    initialState: {
        isOpen: false,
      } as DrawerState,
    reducers: {
        updateDrawer: (state, action: PayloadAction<boolean>) => {
            return {
              ...state,
              isOpen: action.payload
            }
        },
    }
})